/**
 * 2 フェーズ取込でアップロード可能なファイル種別の判定。
 *
 * backend の `upload_url/usecase.py::_resolve_ext` と対応させること:
 *   .zip    → そのまま PUT (サーバが中の先頭 .csv を展開)
 *   .csv.gz → そのまま PUT (圧縮済)
 *   .csv    → クライアント gzip して PUT (非対応ブラウザでは非圧縮のまま)
 * これ以外は presigned 発行が 400 になる。
 */

/** アップロードを受け付ける拡張子 (input の accept 属性にもそのまま使う)。 */
export const UPLOAD_ACCEPTED_EXTENSIONS = [".csv", ".csv.gz", ".zip"] as const;

/** ファイル名が対応拡張子か。 */
export function isAcceptedUploadFile(fileName: string): boolean {
  const name = fileName.toLowerCase();
  return UPLOAD_ACCEPTED_EXTENSIONS.some((ext) => name.endsWith(ext));
}

/** 既に圧縮済/確定拡張子で、クライアント gzip をかけてはいけないファイルか。 */
export function isPreCompressed(fileName: string): boolean {
  const name = fileName.toLowerCase();
  return name.endsWith(".csv.gz") || name.endsWith(".zip");
}
